/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Back_ButtonInputs */

const en_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const fr_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos`)
};

const de_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const it_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const ru_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const es_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

const zh_cn2_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后退`)
};

const ja_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const hi_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीछे`)
};

const pt_pt2_new_project_back_button = /** @type {(inputs: New_Project_Back_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {New_Project_Back_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_back_button = /** @type {((inputs?: New_Project_Back_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Back_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_back_button(inputs)
	if (locale === "de") return de_new_project_back_button(inputs)
	if (locale === "it") return it_new_project_back_button(inputs)
	if (locale === "ru") return ru_new_project_back_button(inputs)
	if (locale === "es") return es_new_project_back_button(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_back_button(inputs)
	if (locale === "ja") return ja_new_project_back_button(inputs)
	if (locale === "hi") return hi_new_project_back_button(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_back_button(inputs)
	return en_new_project_back_button(inputs)
});